import { useState, useEffect } from 'react';
import "./PublicUserDetailsModal.css";
import Modal from "../shared/Modal";
import { validateEmail } from '../shared/responseValidators';

type PublicUserDetailsModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (publicName: string, publicEmail: string) => void;
}

export const PublicUserDetailsModal = ({isOpen, onClose, onSubmit}: PublicUserDetailsModalProps) => {

    const [publicName, setPublicName] = useState<string>("");
    const [publicEmail, setPublicEmail] = useState<string>("");
    const [error, setError] = useState<string>("");

    const handleSubmit = () => {
        if (!validateEmail(publicEmail)) {
            setError("Invalid email address");
            return;
        }

        onSubmit(publicName, publicEmail);
    }

    // const disabled = !publicName || !publicEmail || !validateEmail(publicEmail);
    const disabled = !publicName || !publicEmail ;


    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div className="public-user-details-container">

                <div className="modal-title">
                    Who's commenting?
                </div>
                
                Name
                <input
                    type="text"
                    value={publicName}
                    onChange={(e) => setPublicName(e.target.value)}
                />

                Email
                <input
                    type="text"
                    value={publicEmail}
                    onChange={(e) => {
                        setPublicEmail(e.target.value)
                        setError("");
                    }}
                />

                {error && 
                    <div className="public-user-details-error">
                        {error}
                    </div>
                }

                <div className="modal-buttons">
                    <button 
                        className="button-cancel"
                        onClick={onClose}
                    > 
                        Cancel
                    </button>

                    <button
                        className="button-save"
                        onClick={handleSubmit}
                        disabled={disabled}
                    >
                        Submit
                    </button>
                </div>
                

              
            </div>
      </Modal>
    )
}